/** @format */

import React, { useEffect } from 'react';
import { Table, Input, Button, Space, TableColumnsType } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useVendors } from '../hooks/useVendors';
import { GlobalVendor } from '../types';

/**
 * GlobalNames Component
 * Displays all global vendor names with search and filtering
 */
export const GlobalNames: React.FC = () => {
  const { vendors, loading, fetchVendors } = useVendors();

  useEffect(() => {
    fetchVendors();
  }, [fetchVendors]);

  const columns: TableColumnsType<GlobalVendor> = [
    {
      title: 'Global Name',
      dataIndex: 'globalName',
      key: 'globalName',
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }: any) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder='Search Global Name'
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={() => confirm()}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type='primary'
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size='small'
              style={{ width: 90 }}>
              Search
            </Button>
            <Button
              onClick={() => {
                clearFilters();
              }}
              size='small'
              style={{ width: 90 }}>
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered: boolean) => (
        <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
      ),
      onFilter: (value: any, record: GlobalVendor) =>
        record.globalName
          ? record.globalName
              .toString()
              .toLowerCase()
              .includes(String(value).toLowerCase())
          : '',
      sorter: (a: GlobalVendor, b: GlobalVendor) => a.globalName.localeCompare(b.globalName),
    } as any,
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt: string) => new Date(createdAt).toLocaleString(),
    },
    {
      title: 'Updated At',
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      render: (updatedAt: string) => new Date(updatedAt).toLocaleString(),
    },
  ];

  return (
    <Table<GlobalVendor>
      columns={columns}
      dataSource={vendors}
      loading={loading}
      pagination={{ pageSize: 100 }}
      rowKey={(record) => record._id}
    />
  );
};
